// utils/testUi.js
import {
  BRAND,
  TOKENS,
  StatPill,
  CardShell,
} from "../pages/Test/dashboardShared";
const TEST_UI_REGISTRY = {
  "DISC Test: Behavior Style": {
    type: "dimensional",
    display: "",
    max: 50,
    fields: [
      {
        key: "dominant",
        label: "Dominance",
        colorFrom: "#8b7cf6",
        colorTo: "#6c4fd6",
      },
      {
        key: "influential",
        label: "Influence",
        colorFrom: "#ff9ecf",
        colorTo: BRAND.pink,
      },
      {
        key: "steady",
        label: "Steadiness",
        colorFrom: "#7fe3d0",
        colorTo: BRAND.teal,
      },
      {
        key: "conscientious",
        label: "Conscientious",
        colorFrom: "#ffd27f",
        colorTo: "#f5a623",
      },
    ],
  },
  "Rorschach Inkblot Perception Test": { type: "qualitative" },
  "Work Style Personality Test": {
    type: "dimensional",
    display: "",
    max: 15,
    fields: [
      {
        key: "A",
        label: "Adaptive Style",
        colorFrom: "#8b7cf6",
        colorTo: "#6c4fd6",
      },
      {
        key: "AL",
        label: "Analytical Logical Style",
        colorFrom: "#ff9ecf",
        colorTo: BRAND.pink,
      },
      {
        key: "CO",
        label: "Collaborative Style",
        colorFrom: "#7fe3d0",
        colorTo: BRAND.teal,
      },
      {
        key: "CR",
        label: "Creative Style",
        colorFrom: "#ffd27f",
        colorTo: "#f5a623",
      },
      {
        key: "L",
        label: "Leadership Focused Style",
        colorFrom: "#ff9ecf",
        colorTo: BRAND.pink,
      },
    ],
  },
  "Core Thinking Style Test": {
    type: "dimensional",
    display: "",
    max: 50,
    fields: [
      {
        key: "EX",
        label: "Adaptive Style",
        colorFrom: "#8b7cf6",
        colorTo: "#6c4fd6",
      },
      {
        key: "BU",
        label: "Analytical Logical Style",
        colorFrom: "#ff9ecf",
        colorTo: BRAND.pink,
      },
      {
        key: "NE",
        label: "Collaborative Style",
        colorFrom: "#7fe3d0",
        colorTo: BRAND.teal,
      },
      {
        key: "DI",
        label: "Creative Style",
        colorFrom: "#ffd27f",
        colorTo: "#f5a623",
      },
    ],
  },
  "What's Your Natural Sleep Pattern?": {
    type: "dimensional",
    display: "",
    max: 22,
    fields: [
      {
        key: "bear",
        label: "Bear",
        colorFrom: "#8b7cf6",
        colorTo: "#6c4fd6",
      },
      {
        key: "lion",
        label: "Lion",
        colorFrom: "#ff9ecf",
        colorTo: BRAND.pink,
      },
      {
        key: "dolphin",
        label: "Dolphin",
        colorFrom: "#7fe3d0",
        colorTo: BRAND.teal,
      },
      {
        key: "wolf",
        label: "Wolf",
        colorFrom: "#ffd27f",
        colorTo: "#f5a623",
      },
    ],
  },
  "Ikigai Test": {
    type: "dimensional",
    display: "",
    max: 20,
    fields: [
      {
        key: "Connection",
        label: "Connection",
        colorFrom: "#8b7cf6",
        colorTo: "#6c4fd6",
      },
      {
        key: "Action",
        label: "Action",
        colorFrom: "#ff9ecf",
        colorTo: BRAND.pink,
      },
      {
        key: "Learning",
        label: "Learning",
        colorFrom: "#7fe3d0",
        colorTo: BRAND.teal,
      },
      {
        key: "Optimization",
        label: "Optimization",
        colorFrom: "#ffd27f",
        colorTo: "#f5a623",
      },
      {
        key: "Creation",
        label: "Creation",
        colorFrom: "#ff9ecf",
        colorTo: BRAND.pink,
      },
    ],
  },
  "OCEAN Test: Big Five Traits": {
    type: "dimensional",
    display: "",
    max: 14,
    fields: [
      {
        key: "extraversion",
        label: "Extraversion",
        colorFrom: "#8b7cf6",
        colorTo: "#6c4fd6",
      },
      {
        key: "conscientiousness",
        label: "Conscientiousness",
        colorFrom: "#ff9ecf",
        colorTo: BRAND.pink,
      },
      {
        key: "agreeableness",
        label: "Agreeableness",
        colorFrom: "#7fe3d0",
        colorTo: BRAND.teal,
      },
      {
        key: "neuroticism",
        label: "Neuroticism",
        colorFrom: "#ffd27f",
        colorTo: "#f5a623",
      },
      {
        key: "openness",
        label: "Openness",
        colorFrom: "#ff9ecf",
        colorTo: BRAND.pink,
      },
    ],
  },
  "Adult Attachment Style Test": {
    type: "dimensional",
    display: "",
    max: 60,
    fields: [
      {
        key: "secure",
        label: "Secure",
        colorFrom: "#8b7cf6",
        colorTo: "#6c4fd6",
      },
      {
        key: "av",
        label: "Avoidant",
        colorFrom: "#ff9ecf",
        colorTo: BRAND.pink,
      },
      {
        key: "an",
        label: "Anxious",
        colorFrom: "#7fe3d0",
        colorTo: BRAND.teal,
      },
      {
        key: "da",
        label: "Disorganized",
        colorFrom: "#ffd27f",
        colorTo: "#f5a623",
      },
    ],
  },
  "Are You a Risk Taker or a Safety Seeker?": {
    type: "dimensional",
    display: "",
    max: 30,
    fields: [
      {
        key: "Financial",
        label: "Financial",
        colorFrom: "#8b7cf6",
        colorTo: "#6c4fd6",
      },
      {
        key: "Career",
        label: "Career",
        colorFrom: "#ff9ecf",
        colorTo: BRAND.pink,
      },
      {
        key: "Relationship",
        label: "Relationship",
        colorFrom: "#7fe3d0",
        colorTo: BRAND.teal,
      },
      {
        key: "Social",
        label: "Social",
        colorFrom: "#ffd27f",
        colorTo: "#f5a623",
      },
    ],
  },
  "Carl Jung Personality Archetype Test": {
    type: "dimensional",
    display: "radial",
    max: 8,
    fields: [
      {
        key: "Caregiver",
        label: "Caregiver",
        colorFrom: "#7fe3d0",
        colorTo: "#34d9b8",
      },
      {
        key: "Explorer",
        label: "Explorer",
        colorFrom: "#86efac",
        colorTo: "#22c55e",
      },
      {
        key: "Creator",
        label: "Creator",
        colorFrom: "#8b7cf6",
        colorTo: "#6c4fd6",
      },
      {
        key: "Innocent",
        label: "Innocent",
        colorFrom: "#7dd3fc",
        colorTo: "#38bdf8",
      },
      {
        key: "Rebel",
        label: "Rebel",
        colorFrom: "#fca5a5",
        colorTo: "#ef4444",
      },
      { key: "Hero", label: "Hero", colorFrom: "#fdba74", colorTo: "#f97316" },
      {
        key: "Everyman",
        label: "Everyman",
        colorFrom: "#cbd5e1",
        colorTo: "#94a3b8",
      },
      {
        key: "Ruler",
        label: "Ruler",
        colorFrom: "#a5b4fc",
        colorTo: "#6366f1",
      },
      {
        key: "Lover",
        label: "Lover",
        colorFrom: "#ff9ecf",
        colorTo: BRAND.pink,
      },
      { key: "Sage", label: "Sage", colorFrom: "#93c5fd", colorTo: "#2563eb" },
      {
        key: "Magician",
        label: "Magician",
        colorFrom: "#f0abfc",
        colorTo: "#d946ef",
      },
      {
        key: "Jester",
        label: "Jester",
        colorFrom: "#fde047",
        colorTo: "#eab308",
      },
    ],
  },
  "Enneagram Test: Core Motivation": {
    type: "dimensional",
    display: "radial",
    max: 12,
    fields: [
      {
        key: "Perfectionist",
        label: "Perfectionist",
        colorFrom: "#7fe3d0",
        colorTo: "#34d9b8",
      },
      {
        key: "ConsiderateHelper",
        label: "ConsiderateHelper",
        colorFrom: "#86efac",
        colorTo: "#22c55e",
      },
      {
        key: "Achiever",
        label: "Achiever",
        colorFrom: "#8b7cf6",
        colorTo: "#6c4fd6",
      },
      {
        key: "Individualist",
        label: "Individualist",
        colorFrom: "#7dd3fc",
        colorTo: "#38bdf8",
      },
      {
        key: "Investigator",
        label: "Investigator",
        colorFrom: "#fca5a5",
        colorTo: "#ef4444",
      },
      {
        key: "Loyalist",
        label: "Loyalist",
        colorFrom: "#fdba74",
        colorTo: "#f97316",
      },
      {
        key: "Enthusiast",
        label: "Enthusiast",
        colorFrom: "#cbd5e1",
        colorTo: "#94a3b8",
      },
      {
        key: "Challenger",
        label: "Challenger",
        colorFrom: "#a5b4fc",
        colorTo: "#6366f1",
      },
      {
        key: "Peacemaker",
        label: "Peacemaker",
        colorFrom: "#ff9ecf",
        colorTo: BRAND.pink,
      },
    ],
  },
  "MBTI Chakra Test: Energy & Type": {
    type: "dimensional",
    display: "zoneGauge",
    max: 15,
    thresholds: { low: 33, high: 68 }, // optional override, defaults to 33/68
    fields: [
      {
        key: "Sacral_Chakra",
        label: "Sacral Chakra",
        colorFrom: "#7fe3d0",
        colorTo: "#34d9b8",
      },
      {
        key: "Solar_Plexus_Chakra",
        label: "Solar Plexus Chakra",
        colorFrom: "#86efac",
        colorTo: "#22c55e",
      },
      {
        key: "Throat_Chakra",
        label: "Throat Chakra",
        colorFrom: "#8b7cf6",
        colorTo: "#6c4fd6",
      },
      {
        key: "Heart_Chakra",
        label: "Heart Chakra",
        colorFrom: "#7dd3fc",
        colorTo: "#38bdf8",
      },
      {
        key: "Crown_Chakra",
        label: "Crown Chakra",
        colorFrom: "#fca5a5",
        colorTo: "#ef4444",
      },
      {
        key: "Third_Eye_Chakra",
        label: "Third Eye Chakra",
        colorFrom: "#fdba74",
        colorTo: "#f97316",
      },
      {
        key: "Root_Chakra",
        label: "Root Chakra",
        colorFrom: "#cbd5e1",
        colorTo: "#94a3b8",
      },
    ],
  },
  "Bioenergetic Body-Mind Type Test": {
    type: "dimensional",
    display: "",
    max: 30,
    fields: [
      {
        key: "Thinker",
        label: "Thinker",
        colorFrom: "#8b7cf6",
        colorTo: "#6c4fd6",
      },
      {
        key: "Influencer",
        label: "Influencer",
        colorFrom: "#ff9ecf",
        colorTo: BRAND.pink,
      },
      {
        key: "Endurer",
        label: "Endurer",
        colorFrom: "#7fe3d0",
        colorTo: BRAND.teal,
      },
      {
        key: "Leader",
        label: "Leader",
        colorFrom: "#ffd27f",
        colorTo: "#f5a623",
      },
      {
        key: "Achiever",
        label: "Achiever",
        colorFrom: "#ffd27f",
        colorTo: "#f5a623",
      },
    ],
  },
  // defence
  "How Strong Are Your Defense Mechanisms?": {
    type: "defense",
    display: "donut",
    fields: [
      {
        key: "mature",
        label: "Mature Defenses",
        colorFrom: "#7fe3d0",
        colorTo: "#34d9b8",
      },
      {
        key: "neurotic",
        label: "Neurotic Defenses",
        colorFrom: "#86efac",
        colorTo: "#22c55e",
      },
      {
        key: "immature",
        label: "Immature Defenses",
        colorFrom: "#8b7cf6",
        colorTo: "#6c4fd6",
      },
    ],
  },
  "Erotic Sexual Test: Desire Style": {
    type: "defense",
    display: "donut",
    fields: [
      {
        key: "rebel",
        label: "Rebel",
        color: "#22C55E",
      },
      {
        key: "chameleon",
        label: "Chameleon",
        color: "#3B82F6",
      },
    ],
  },
  "Ayurveda Test": {
    type: "defense",
    display: "donut",
    fields: [
      {
        key: "vata",
        label: "Vata",
        color: "#22C55E",
      },
      {
        key: "kapha",
        label: "kapha",
        color: "#3B82F6",
      },
      {
        key: "pitta",
        label: "Pitta",
        color: "#F59E0B",
      },
    ],
  },
  "Guilt Test": {
    type: "defense",
    display: "donut",
    fields: [
      {
        key: "healthy",
        label: "Healthy",
        color: "#22C55E",
      },
      {
        key: "Unhealthy",
        label: "Unhealthy",
        color: "#3B82F6",
      },
    ],
  },
  "Personal Values Test": {
    type: "dimensional",
    display: "radial",
    max: 15,
    fields: [
      {
        key: "selfDirection",
        label: "SelfDirection",
        colorFrom: "#7fe3d0",
        colorTo: "#34d9b8",
      },
      {
        key: "stimulation",
        label: "Stimulation",
        colorFrom: "#86efac",
        colorTo: "#22c55e",
      },
      {
        key: "hedonism",
        label: "Hedonism",
        colorFrom: "#8b7cf6",
        colorTo: "#6c4fd6",
      },
      {
        key: "achievement",
        label: "Achievement",
        colorFrom: "#7dd3fc",
        colorTo: "#38bdf8",
      },
      {
        key: "security",
        label: "Security",
        colorFrom: "#fca5a5",
        colorTo: "#ef4444",
      },
      {
        key: "conformity",
        label: "Conformity",
        colorFrom: "#fdba74",
        colorTo: "#f97316",
      },
      {
        key: "tradition",
        label: "Rradition",
        colorFrom: "#cbd5e1",
        colorTo: "#94a3b8",
      },
      {
        key: "benevolence",
        label: "Benevolence",
        colorFrom: "#a5b4fc",
        colorTo: "#6366f1",
      },
      {
        key: "universalism",
        label: "Universalism",
        colorFrom: "#ff9ecf",
        colorTo: BRAND.pink,
      },
    ],
  },

  "Personality Style Test: Discover Your Unique Personality": {
    type: "archetype",
    display: "",
    max: 8,
    fields: [
      {
        key: "Thinker",
        label: "Thinker",
        color: "#3B82F6",
        colorFrom: "#8b7cf6",
        colorTo: "#6c4fd6",
      },
      {
        key: "Upholder",
        label: "Upholder",
        color: "#22C55E",
        colorFrom: "#ff9ecf",
        colorTo: "#38bdf8",
      },
      {
        key: "Leader",
        label: "Leader",
        color: "#F59E0B",
        colorFrom: "#7fe3d0",
        colorTo: "#2563eb",
      },
    ],
  },
  "Anger Style Test": {
    type: "archetype",
    display: "",
    fields: [
      {
        key: "Assertive",
        label: "Assertive",
        color: "#8B5CF6",
        colorFrom: "#8b7cf6",
        colorTo: "#6c4fd6",
      },
      {
        key: "Passive",
        label: "Passive",
        color: "#38BDF8",
        colorFrom: "#ff9ecf",
        colorTo: "#38bdf8",
      },
      {
        key: "Suppressed",
        label: "Suppressed",
        color: "#2563EB",
        colorFrom: "#7fe3d0",
        colorTo: "#2563eb",
      },
      {
        key: "Confrontational",
        label: "Confrontational",
        color: "#E907ED",
        colorFrom: "#f472b6",
        colorTo: "#e907ed",
      },
    ],
  },
  "Money Script Test": {
    type: "archetype",
    display: "",
    max: 8,
    fields: [
      {
        key: "MoneyAvoidance",
        label: "Money Avoidance",
        color: "#3B82F6",
        colorFrom: "#8b7cf6",
        colorTo: "#6c4fd6",
      },
      {
        key: "MoneyFocus",
        label: "Money Focus",
        color: "#22C55E",
        colorFrom: "#ff9ecf",
        colorTo: "#38bdf8",
      },
      {
        key: "MoneyVigilance",
        label: "Money Vigilance",
        color: "#F59E0B",
        colorFrom: "#7fe3d0",
        colorTo: "#2563eb",
      },
      {
        key: "MoneyStatus",
        label: "Money Status",
        color: "#EC4899",
        colorFrom: "#f472b6",
        colorTo: "#db2777",
      },
    ],
  },
  "Discover Your Female Archetype": {
    type: "dimensional",
    display: "radial",
    max: 24,
    fields: [
      {
        key: "MA",
        label: "The Maiden",
        colorFrom: "#7fe3d0",
        colorTo: "#34d9b8",
      },
      {
        key: "WW",
        label: "The Wild Woman",
        colorFrom: "#86efac",
        colorTo: "#22c55e",
      },
      {
        key: "MY",
        label: "The Mystic",
        colorFrom: "#8b7cf6",
        colorTo: "#6c4fd6",
      },
      {
        key: "LV",
        label: "The Lover",
        colorFrom: "#7dd3fc",
        colorTo: "#38bdf8",
      },
      {
        key: "HU",
        label: "The Huntress",
        colorFrom: "#fca5a5",
        colorTo: "#ef4444",
      },
      {
        key: "QU",
        label: "The Queen",
        colorFrom: "#fdba74",
        colorTo: "#f97316",
      },
      {
        key: "MO",
        label: "The Mother",
        colorFrom: "#cbd5e1",
        colorTo: "#94a3b8",
      },
      {
        key: "DG",
        label: "The Dark Goddess",
        colorFrom: "#a5b4fc",
        colorTo: "#6366f1",
      },
      {
        key: "Lover",
        label: "Lover",
        colorFrom: "#ff9ecf",
        colorTo: BRAND.pink,
      },
      { key: "Sage", label: "Sage", colorFrom: "#93c5fd", colorTo: "#2563eb" },
      {
        key: "Magician",
        label: "Magician",
        colorFrom: "#f0abfc",
        colorTo: "#d946ef",
      },
      {
        key: "Jester",
        label: "Jester",
        colorFrom: "#fde047",
        colorTo: "#eab308",
      },
    ],
  },
  "Are You Functionally Frozen or Just Procrastinating?": {
    type: "dimensional",
    display: "radial",
    fields: [
      {
        key: "P",
        label: "Procrastination",
        color: "#c9a58a",
      },
      {
        key: "FF",
        label: "Functional Freeze",
        color: "#8b9dc3",
      },
      {
        key: "LM",
        label: "Low Motivation",
        color: "#8b7cf6",
      },
      {
        key: "B",
        label: "Burnout",
        color: "#8b9dc3",
      },
    ],
  },
  "How Are You Coping With Grief Test?": {
    type: "dimensional",
    display: "",
    fields: [
      {
        key: "Emotional",
        label: "Emotional",
        color: "#C93D6E",
      },
      {
        key: "Coping",
        label: "Coping",
        colorFrom: "#9B71D2",
        colorTo: BRAND.pink,
      },
      {
        key: "Expression",
        label: "Expression",
        colorFrom: "#7fe3d0",
        colorTo: BRAND.teal,
      },
      {
        key: "Integration",
        label: "Integration",
        colorFrom: "#C93D6E",
        colorTo: "#f5a623",
      },
    ],
  },
  //syndrome
  // "Child Syndrome Test: Explore Childhood Behavioral Patterns": {
  //   type: "syndrome",
  //   display: "",
  //   max: 15,
  //   fields: [
  //     {
  //       key: "EmotionalBurden",
  //       label: "Emotional Burden",
  //       color: "#C93D6E",
  //     },
  //     {
  //       key: "PeoplePleasing",
  //       label: "People Pleasing",
  //       color: "#9B71D2",
  //     },
  //     {
  //       key: "Perfectionism",
  //       label: "Perfectionism",
  //       color: "#7fe3d0",
  //     },
  //     {
  //       key: "Difficulty",
  //       label: "Difficulty",
  //       color: "#f5a623",
  //     },
  //     {
  //       key: "Fear",
  //       label: "Fear",
  //       color: "#9B71D2",
  //     },
  //     {
  //       key: "Resentment",
  //       label: "Resentment",
  //       color: "#7fe3d0",
  //     },
  //     {
  //       key: "SelfEsteem",
  //       label: "SelfEsteem",
  //       colorFrom: "#C93D6E",
  //       colorTo: "#f5a623",
  //     },
  //     {
  //       key: "DifficultyWithBoundaries",
  //       label: "Difficulty With Boundaries",
  //       color: "#7fe3d0",
  //     },
  //   ],
  // },
  // "Child Family Dysfunction: Self-Understanding and Insights": {
  //   type: "syndrome",
  //   display: "",
  //   max: 15,
  //   fields: [
  //     {
  //       key: "Identity",
  //       label: "Identity",
  //       color: "#C93D6E",
  //     },
  //     {
  //       key: "Self",
  //       label: "Self",
  //       color: "#9B71D2",
  //     },
  //     {
  //       key: "Emotional",
  //       label: "Emotional",
  //       color: "#7fe3d0",
  //     },
  //     {
  //       key: "Boundaries",
  //       label: "Boundaries",
  //       color: "#f5a623",
  //     },
  //     {
  //       key: "Coping",
  //       label: "Coping",
  //       color: "#9B71D2",
  //     },
  //     {
  //       key: "Trust",
  //       label: "Trust",
  //       color: "#7fe3d0",
  //     },
  //     {
  //       key: "Guilt",
  //       label: "Guilt",
  //       colorFrom: "#C93D6E",
  //       colorTo: "#f5a623",
  //     },
  //     {
  //       key: "Relationship",
  //       label: "Relationship",
  //       color: "#7fe3d0",
  //     },
  //   ],
  // },
  "Travel Personality Test": {
    type: "syndrome",
    display: "",
    max: 12,
    fields: [
      {
        key: "venturers",
        label: "Venturers",
        color: "#C93D6E",
      },
      {
        key: "pioneers",
        label: "Pioneers",
        color: "#9B71D2",
      },
      {
        key: "voyagers",
        label: "Voyagers",
        color: "#7fe3d0",
      },
      {
        key: "journeyers",
        label: "Journeyers",
        color: "#f5a623",
      },
      {
        key: "traditionals",
        label: "Traditionals",
        color: "#9B71D2",
      },
      {
        key: "rejuvenators",
        label: "Rejuvenators",
        color: "#7fe3d0",
      },
      {
        key: "companions",
        label: "Companions",
        colorFrom: "#C93D6E",
        colorTo: "#f5a623",
      },
      {
        key: "sightseers",
        label: "Sight Seers",
        color: "#7fe3d0",
      },
    ],
  },
  // "Know Your Executive Functioning Level": {
  //   type: "syndrome",
  //   display: "",
  //   max: 12,
  //   fields: [
  //     {
  //       key: "Planning",
  //       label: "Planning",
  //       color: "#C93D6E",
  //     },
  //     {
  //       key: "Task",
  //       label: "Task",
  //       color: "#9B71D2",
  //     },
  //     {
  //       key: "Time",
  //       label: "Time",
  //       color: "#7fe3d0",
  //     },
  //     {
  //       key: "Attention",
  //       label: "Attention",
  //       color: "#f5a623",
  //     },
  //     {
  //       key: "Working",
  //       label: "Working",
  //       color: "#9B71D2",
  //     },
  //     {
  //       key: "Cognitive",
  //       label: "Cognitive",
  //       color: "#7fe3d0",
  //     },
  //     {
  //       key: "Emotional",
  //       label: "Emotional",
  //       colorFrom: "#C93D6E",
  //       colorTo: "#f5a623",
  //     },
  //     {
  //       key: "Impulse",
  //       label: "Impulse",
  //       color: "#7fe3d0",
  //     },
  //     {
  //       key: "Awareness",
  //       label: "Awareness",
  //       color: "#C93D6E",
  //     },
  //   ],
  // },

  //cat

  "Specialist vs Generalist Test": {
    type: "categorical",
    display: "",
    max: 16,
    fields: [
      {
        key: "generalist",
        label: "Generalist",
        color: "#22C55E",
        mechanisms: ["Generalist"],
      },
      {
        key: "specialist",
        label: "Specialist",
        color: "#3B82F6",
        mechanisms: ["Specialist"],
      },
    ],
  },
  "Bipolar Disorder Test": {
    type: "categorical",
    display: "",
    max: 90,
    fields: [
      {
        key: "Mania",
        label: "Mania",
        color: "#22C55E",
        mechanisms: ["Mania"],
      },
      {
        key: "Depressive",
        label: "Depressive",
        color: "#3B82F6",
        mechanisms: ["Depressive"],
      },
    ],
  },
  "What's Your Political Ideology?": {
    type: "categorical",
    display: "",
    max: 24,
    fields: [
      {
        key: "EconomicAxis",
        label: "Economic Axis",
        color: "#22C55E",
        mechanisms: ["EconomicAxis"],
      },
      {
        key: "SocialAxis",
        label: "Social Axis",
        color: "#3B82F6",
        mechanisms: ["SocialAxis"],
      },
    ],
  },
  "Independent or Team Player Test": {
    type: "categorical",
    display: "",
    max: 24,
    fields: [
      {
        key: "IndependentOrientation",
        label: "Independent Orientation",
        color: "#22C55E",
        mechanisms: [],
      },
      {
        key: "TeamPlayer",
        label: "Team Player",
        color: "#3B82F6",
        mechanisms: [],
      },
    ],
  },
  //dimensional
  "Love Expression Test: How You Feel Loved": {
    type: "syndrome",
    display: "",
    max: 10,
    fields: [
      {
        key: "words_of_affirmation",
        label: "Appreciation",
        color: "#C93D6E",
      },
      {
        key: "physical_touch",
        label: "Touch",
        color: "#9B71D2",
      },
      {
        key: "shared_values_beliefs",
        label: "Shared Values & Beliefs",
        color: "#7fe3d0",
      },
      {
        key: "understanding_knowing",
        label: "Understanding",
        color: "#f5a623",
      },
      {
        key: "growth_adaptation",
        label: "Growth & Adaptation",
        color: "#9B71D2",
      },
      {
        key: "receiving_gifts",
        label: "Gifts and Tokens",
        color: "#7fe3d0",
      },
      {
        key: "acts_of_service",
        label: "Service",
        colorFrom: "#C93D6E",
        colorTo: "#f5a623",
      },
      {
        key: "quality_time",
        label: "Time",
        color: "#7fe3d0",
      },
    ],
  },
  "Trauma Response Test": {
    type: "dimensional",
    display: "",
    max: 23,
    fields: [
      {
        key: "FIGHT",
        label: "Fight",
        colorFrom: "#8b7cf6",
        colorTo: "#6c4fd6",
      },
      {
        key: "FLIGHT",
        label: "Flight",
        colorFrom: "#ff9ecf",
        colorTo: BRAND.pink,
      },
      {
        key: "FREEZE",
        label: "Freeze",
        colorFrom: "#7fe3d0",
        colorTo: BRAND.teal,
      },
      {
        key: "FAWN",
        label: "Fawn",
        colorFrom: "#ffd27f",
        colorTo: "#f5a623",
      },
    ],
  },
  "Spiritual Abuse Test": {
    type: "syndrome",
    display: "",
    max: 15,
    fields: [
      {
        key: "Overt",
        label: "Overt",
        colorFrom: "#8b7cf6",
        colorTo: "#6c4fd6",
      },
      {
        key: "Physical",
        label: "Physical",
        colorFrom: "#ff9ecf",
        colorTo: "#ff9ecf",
      },
      {
        key: "Covert",
        label: "Covert",
        colorFrom: "#7fe3d0",
        colorTo: "#7fe3d0",
      },
    ],
  },
  "Caregiver Burnout Test": {
    type: "syndrome",
    display: "",
    max: 15,
    fields: [
      {
        key: "Generaldemographics",
        label: "General Demographics",
        colorFrom: "#8b7cf6",
        colorTo: "#6c4fd6",
      },
      {
        key: "Psychologicaldistress",
        label: "Psycho Logical Distress",
        colorFrom: "#ff9ecf",
        colorTo: "#ff9ecf",
      },
      {
        key: "Socialsupport",
        label: "Social Support",
        colorFrom: "#7fe3d0",
        colorTo: "#7fe3d0",
      },
    ],
  },
  "Toxic Shame Test": {
    type: "dimensional",
    display: "",
    max: 9,
    fields: [
      {
        key: "wounds",
        label: "Wounds",
        colorFrom: "#8b7cf6",
        colorTo: "#6c4fd6",
      },
      {
        key: "comparison",
        label: "Comparison",
        colorFrom: "#ff9ecf",
        colorTo: "#ff9ecf",
      },
      {
        key: "exposure",
        label: "Exposure",
        colorFrom: "#7fe3d0",
        colorTo: "#7fe3d0",
      },
      {
        key: "rejection",
        label: "Rejection",
        colorFrom: "#ffd27f",
        colorTo: "#f5a623",
      },
    ],
  },
  "Kama Personality Test": {
    type: "syndrome",
    display: "",
    max: 20,
    fields: [
      {
        key: "Shastra",
        label: "Shastra",
        colorFrom: "#8b7cf6",
        colorTo: "#6c4fd6",
      },
      {
        key: "Vrishabha",
        label: "Vrishabha",
        colorFrom: "#ff9ecf",
        colorTo: "#ff9ecf",
      },
      {
        key: "Ashwa",
        label: "Ashwa",
        colorFrom: "#7fe3d0",
        colorTo: "#7fe3d0",
      },
    ],
  },
  "Relationship Belief Test": {
    type: "dimensional",
    display: "",
    max: 32,
    fields: [
      {
        key: "Disagreement",
        label: "Disagreement is Destructive",
        colorFrom: "#8b7cf6",
        colorTo: "#6c4fd6",
      },
      {
        key: "MindReading",
        label: "Mind Reading is Expected",
        colorFrom: "#ff9ecf",
        colorTo: "#6c4fd6",
      },
      {
        key: "Partners",
        label: "Partners Cannot Change",
        colorFrom: "#7fe3d0",
        colorTo: "#ff9ecf",
      },
      {
        key: "Sexual",
        label: "Sexual Perfectionism",
        colorFrom: "#ffd27f",
        colorTo: "#f5a623",
      },
      {
        key: "Fundamentally",
        label: "The Sexes are Fundamentally Different",
        colorFrom: "#ff9ecf",
        colorTo: "#ffd27f",
      },
    ],
  },
  "Love Attitude Test": {
    type: "dimensional",
    display: "",
    max: 9,
    fields: [
      {
        key: "Eros",
        label: "Eros",
        colorFrom: "#8b7cf6",
        colorTo: "#6c4fd6",
      },
      {
        key: "Ludus",
        label: "Ludus",
        colorFrom: "#ff9ecf",
        colorTo: "#6c4fd6",
      },
      {
        key: "Storge",
        label: "Storge",
        colorFrom: "#7fe3d0",
        colorTo: "#ff9ecf",
      },
      {
        key: "Mania",
        label: "Mania",
        colorFrom: "#ffd27f",
        colorTo: "#f5a623",
      },
      {
        key: "Pragma",
        label: "Pragma",
        colorFrom: "#ff9ecf",
        colorTo: "#ffd27f",
      },
      {
        key: "Agape",
        label: "Agape",
        colorFrom: "#7fe3d0",
        colorTo: "#ff9ecf",
      },
    ],
  },
  // "Relationship Health Test": {
  //   type: "dimensional",
  //   display: "",
  //   max: 20,
  //   fields: [
  //     {
  //       key: "Safety",
  //       label: "Safety",
  //       colorFrom: "#8b7cf6",
  //       colorTo: "#6c4fd6",
  //     },
  //     {
  //       key: "EmoConn",
  //       label: "Emotional Connection",
  //       colorFrom: "#ff9ecf",
  //       colorTo: BRAND.pink,
  //     },
  //     {
  //       key: "RespectEqual",
  //       label: "Respect Equal",
  //       colorFrom: "#7fe3d0",
  //       colorTo: BRAND.teal,
  //     },
  //     {
  //       key: "Optimization",
  //       label: "Optimization",
  //       colorFrom: "#ffd27f",
  //       colorTo: "#f5a623",
  //     },
  //     {
  //       key: "IsYourRelationshipHealthy",
  //       label: "Relationship Healthy",
  //       colorFrom: "#ff9ecf",
  //       colorTo: BRAND.pink,
  //     },
  //   ],
  // },
  "Am I the Fixer in Relationships?": {
    type: "syndrome",
    display: "",
    max: 25,
    fields: [
      {
        key: "emotional",
        label: "Emotional",
        colorFrom: "#8b7cf6",
        colorTo: "#6c4fd6",
      },
      {
        key: "relationship",
        label: "Relationship",
        colorFrom: "#ff9ecf",
        colorTo: "#ff9ecf",
      },
      {
        key: "helping",
        label: "Helping",
        colorFrom: "#7fe3d0",
        colorTo: "#7fe3d0",
      },
    ],
  },
  // "Relationship Commitment Test": {
  //   type: "dimensional",
  //   display: "",
  //   max: 15,
  //   fields: [
  //     {
  //       key: "Avoidance",
  //       label: "Avoidance",
  //       colorFrom: "#8b7cf6",
  //       colorTo: "#6c4fd6",
  //     },
  //     {
  //       key: "EarlyExperience",
  //       label: "Early Experience",
  //       colorFrom: "#ff9ecf",
  //       colorTo: "#6c4fd6",
  //     },
  //     {
  //       key: "FearOfLosing",
  //       label: "Fear Of Losing",
  //       colorFrom: "#7fe3d0",
  //       colorTo: "#ff9ecf",
  //     },
  //     {
  //       key: "SelfDetermination",
  //       label: "Self Determination",
  //       colorFrom: "#ffd27f",
  //       colorTo: "#f5a623",
  //     },
  //     {
  //       key: "SocialLearning",
  //       label: "Social Learning",
  //       colorFrom: "#ff9ecf",
  //       colorTo: "#ffd27f",
  //     },
  //     {
  //       key: "SocialExchange",
  //       label: "Social Exchange",
  //       colorFrom: "#7fe3d0",
  //       colorTo: "#ff9ecf",
  //     },
  //   ],
  // },
  "Love Spark Test": {
    type: "syndrome",
    display: "",
    fields: [
      {
        key: "Intimacy",
        label: "Intimacy",
        colorFrom: "#8b7cf6",
        colorTo: "#6c4fd6",
      },
      {
        key: "Passion",
        label: "Passion",
        colorFrom: "#ff9ecf",
        colorTo: "#ff9ecf",
      },
      {
        key: "Commitment",
        label: "Commitment",
        colorFrom: "#7fe3d0",
        colorTo: "#7fe3d0",
      },
    ],
  },
  // "Codependency Test": {
  //   type: "dimensional",
  //   display: "",
  //   max: 20,
  //   fields: [
  //     {
  //       key: "OverResponsibility",
  //       label: "Over-Responsibility",
  //       colorFrom: "#8b7cf6",
  //       colorTo: "#6c4fd6",
  //     },
  //     {
  //       key: "SelfSuppression",
  //       label: "Self-Suppression",
  //       colorFrom: "#ff9ecf",
  //       colorTo: "#6c4fd6",
  //     },
  //     {
  //       key: "FearBasedAttachment",
  //       label: "Fear-Based Attachment",
  //       colorFrom: "#7fe3d0",
  //       colorTo: "#ff9ecf",
  //     },
  //     {
  //       key: "ResentfulOvergiving",
  //       label: "Resentful Overgiving",
  //       colorFrom: "#ffd27f",
  //       colorTo: "#f5a623",
  //     },
  //     {
  //       key: "UnworthyGiving",
  //       label: "Unworthy Giving",
  //       colorFrom: "#ff9ecf",
  //       colorTo: "#ffd27f",
  //     },
  //     {
  //       key: "LonelyConnection",
  //       label: "Lonely Connection",
  //       colorFrom: "#7fe3d0",
  //       colorTo: "#ff9ecf",
  //     },
  //   ],
  // },
  // "Dependent Personality Test": {
  //   type: "dimensional",
  //   display: "",
  //   max: 20,
  //   fields: [
  //     {
  //       key: "insecure",
  //       label: "Insecure",
  //       color: "#C93D6E",
  //     },
  //     {
  //       key: "core",
  //       label: "Core",
  //       color: "#9B71D2",
  //     },
  //     {
  //       key: "avoidance",
  //       label: "Avoidance",
  //       color: "#7fe3d0",
  //     },
  //     {
  //       key: "accomodating",
  //       label: "Accomodating",
  //       color: "#f5a623",
  //     },
  //     {
  //       key: "disquieted",
  //       label: "Disquieted",
  //       color: "#9B71D2",
  //     },
  //     {
  //       key: "immature",
  //       label: "Immature",
  //       color: "#7fe3d0",
  //     },
  //     {
  //       key: "ineffectual",
  //       label: "Ineffectual",
  //       colorFrom: "#C93D6E",
  //       colorTo: "#f5a623",
  //     },
  //     {
  //       key: "selfless",
  //       label: "Selfless",
  //       color: "#7fe3d0",
  //     },
  //   ],
  // },
  "RIASEC Career Interest Assessment": {
    type: "dimensional",
    display: "",
    max: 24,
    fields: [
      {
        key: "Realistic",
        label: "Realistic",
        colorFrom: "#8b7cf6",
        colorTo: "#6c4fd6",
      },
      {
        key: "Investigative",
        label: "Investigative",
        colorFrom: "#ff9ecf",
        colorTo: "#6c4fd6",
      },
      {
        key: "Artistic",
        label: "Artistic",
        colorFrom: "#7fe3d0",
        colorTo: "#ff9ecf",
      },
      {
        key: "Social",
        label: "Social",
        colorFrom: "#ffd27f",
        colorTo: "#f5a623",
      },
      {
        key: "Enterprising",
        label: "Enterprising",
        colorFrom: "#ff9ecf",
        colorTo: "#ffd27f",
      },
      {
        key: "Conventional",
        label: "Conventional",
        colorFrom: "#7fe3d0",
        colorTo: "#ff9ecf",
      },
    ],
  },
  "Glimmer Test: Can You Notice the Good Stuff?": {
    type: "dimensional",
    display: "",
    max: 16,
    fields: [
      {
        key: "Noticing",
        label: "Realistic",
        colorFrom: "#8b7cf6",
        colorTo: "#6c4fd6",
      },
      {
        key: "Feeling",
        label: "Feeling",
        colorFrom: "#ff9ecf",
        colorTo: "#6c4fd6",
      },
      {
        key: "Staying",
        label: "Staying",
        colorFrom: "#7fe3d0",
        colorTo: "#ff9ecf",
      },
      {
        key: "LiveDaytoDay",
        label: "Live Day to Day",
        colorFrom: "#ffd27f",
        colorTo: "#f5a623",
      },
    ],
  },
  "Your Core Coping Mechanism Test": {
    type: "dimensional",
    display: "",
    max: 20,
    fields: [
      {
        key: "Deflection",
        label: "Deflection",
        colorFrom: "#8b7cf6",
        colorTo: "#6c4fd6",
      },
      {
        key: "Intellectualising",
        label: "Intellectualising",
        colorFrom: "#ff9ecf",
        colorTo: "#6c4fd6",
      },
      {
        key: "Overachievement",
        label: "Overachievement",
        colorFrom: "#7fe3d0",
        colorTo: "#ff9ecf",
      },
      {
        key: "Hyper-independence",
        label: "Hyper-independence",
        colorFrom: "#ffd27f",
        colorTo: "#f5a623",
      },
      {
        key: "Deprioritisation",
        label: "Deprioritisation",
        colorFrom: "#ff9ecf",
        colorTo: "#ffd27f",
      },
    ],
  },
  "How Much Do You Rely on Validation?": {
    type: "dimensional",
    display: "",
    max: 16,
    fields: [
      {
        key: "Reactions",
        label: "Reactions",
        colorFrom: "#8b7cf6",
        colorTo: "#6c4fd6",
      },
      {
        key: "Overexplaining",
        label: "Over Explaining",
        colorFrom: "#ff9ecf",
        colorTo: "#6c4fd6",
      },
      {
        key: "Fear",
        label: "Fear",
        colorFrom: "#7fe3d0",
        colorTo: "#ff9ecf",
      },
      {
        key: "Productivity",
        label: "Productivity",
        colorFrom: "#ffd27f",
        colorTo: "#f5a623",
      },
      {
        key: "Performing",
        label: "Performing",
        colorFrom: "#ff9ecf",
        colorTo: "#ffd27f",
      },
    ],
  },
  "Gardner’s Test of Multiple Intelligences": {
    type: "syndrome",
    display: "",
    max: 4,
    fields: [
      {
        key: "a",
        label: "Logical",
        colorFrom: "#8b7cf6",
        colorTo: "#6c4fd6",
      },
      {
        key: "b",
        label: "Linguistic",
        colorFrom: "#ff9ecf",
        colorTo: "#6c4fd6",
      },
      {
        key: "f",
        label: "Spatial",
        colorFrom: "#7fe3d0",
        colorTo: "#ff9ecf",
      },
      {
        key: "g",
        label: "Interpersonal",
        colorFrom: "#ffd27f",
        colorTo: "#f5a623",
      },
      {
        key: "fg",
        label: "Intrapersonal",
        colorFrom: "#ff9ecf",
        colorTo: "#ffd27f",
      },
      {
        key: "j",
        label: "Bodily-Kinesthetic",
        colorFrom: "#8b7cf6",
        colorTo: "#6c4fd6",
      },
      {
        key: "jk",
        label: "Musical",
        colorFrom: "#ff9ecf",
        colorTo: "#6c4fd6",
      },
      {
        key: "k",
        label: "Naturalistic",
        colorFrom: "#7fe3d0",
        colorTo: "#ff9ecf",
      },
      {
        key: "n",
        label: "Existential",
        colorFrom: "#ffd27f",
        colorTo: "#f5a623",
      },
    ],
  },
  "Spiritual Intelligence Test": {
    type: "dimensional",
    display: "",
    max: 30,
    fields: [
      {
        key: "Perception",
        label: "Perception",
        colorFrom: "#8b7cf6",
        colorTo: "#6c4fd6",
      },
      {
        key: "Knowledge",
        label: "Knowledge",
        colorFrom: "#ff9ecf",
        colorTo: "#6c4fd6",
      },
      {
        key: "Understanding",
        label: "Understanding",
        colorFrom: "#7fe3d0",
        colorTo: "#ff9ecf",
      },
      {
        key: "Emotional",
        label: "Emotional",
        colorFrom: "#ffd27f",
        colorTo: "#f5a623",
      },
    ],
  },
  "Discover Your Motivation Type": {
    type: "defense",
    display: "donut",
    fields: [
      {
        key: "Growth",
        label: "Growth",
        color: "#22C55E",
        mechanisms: ["Growth"],
      },
      {
        key: "Achievement",
        label: "Achievement",
        color: "#3B82F6",
        mechanisms: ["Achievement"],
      },
      {
        key: "Freedom",
        label: "Freedom",
        color: "#F59E0B",
        mechanisms: ["Freedom"],
      },
      {
        key: "Purpose",
        label: "Purpose",
        color: "#fffffff",
        mechanisms: ["Purpose"],
      },
      {
        key: "Connection",
        label: "Connection",
        color: "#C93D6E",
        mechanisms: ["Connection"],
      },
    ],
  },
  "Discover Your Leadership": {
    type: "defense",
    display: "donut",
    fields: [
      {
        key: "Commander",
        label: "Commander",
        color: "#FF6B35", // Vibrant Orange
        mechanisms: ["Commander"],
      },
      {
        key: "Coach",
        label: "Coach",
        color: "#3B82F6", // Electric Blue
        mechanisms: ["Coach"],
      },
      {
        key: "Affiliative",
        label: "Affiliative",
        color: "#10B981", // Emerald Green
        mechanisms: ["Affiliative"],
      },
      {
        key: "Visionary",
        label: "Visionary",
        color: "#8B5CF6", // Royal Purple
        mechanisms: ["Visionary"],
      },
      {
        key: "Pacesetter",
        label: "Pacesetter",
        color: "#EC4899", // Hot Pink
        mechanisms: ["Pacesetter"],
      },
      {
        key: "Democratic",
        label: "Democratic",
        color: "#06B6D4", // Bright Cyan
        mechanisms: ["Democratic"],
      },
    ],
  },
  "Procrastination Test: Delay Patterns": {
    type: "syndrome",
    display: "",
    max: 16,
    fields: [
      {
        key: "daily_household_chores",
        label: "Daily Household Chores",
        color: "#C93D6E",
      },
      {
        key: "interpersonal",
        label: "Interpersonal",
        color: "#9B71D2",
      },
      {
        key: "workplace",
        label: "Workplace",
        color: "#7fe3d0",
      },
      {
        key: "overdoer",
        label: "Overdoer",
        color: "#f5a623",
      },
      {
        key: "self_care_and_monetary",
        label: "Self Care And Monetary",
        color: "#9B71D2",
      },
      {
        key: "overdoer",
        label: "Overdoer",
        color: "#7fe3d0",
      },
      {
        key: "Perfectionist",
        label: "Perfectionist",
        colorFrom: "#C93D6E",
        colorTo: "#f5a623",
      },
      {
        key: "Defier",
        label: "Defier",
        color: "#7fe3d0",
      },
      {
        key: "dreamer",
        label: "Dreamer",
        color: "#C93D6E",
      },
      {
        key: "worrier",
        label: "Worrier",
        color: "#9B71D2",
      },
      {
        key: "workplace",
        label: "Workplace",
        color: "#7fe3d0",
      },
      {
        key: "crisis_maker",
        label: "Crisis Maker",
        color: "#f5a623",
      },
    ],
  },
  "OCD Test": {
    type: "dimensional",
    display: "",
    max: 9,
    fields: [
      {
        key: "aggressiveObsessions",
        label: "Aggressive Obsessions",
        color: "#C93D6E",
      },
      {
        key: "contaminationObsessions",
        label: "Contamination Obsessions",
        color: "#9B71D2",
      },
      {
        key: "religiousObsessions",
        label: "Religious Obsessions",
        color: "#7fe3d0",
      },
      {
        key: "contaminationCompulsions",
        label: "Contamination Compulsions",
        color: "#f5a623",
      },
      {
        key: "religiousCompulsions",
        label: "Religious Compulsions",
        color: "#9B71D2",
      },
      {
        key: "somaticCompulsions",
        label: "Somatic Compulsions",
        color: "#7fe3d0",
      },
    ],
  },
  // "Social Anxiety Test: Fear Patterns": {
  //   type: "dimensional",
  //   display: "",
  //   max: 20,
  //   fields: [
  //     {
  //       key: "Interactions",
  //       label: "Interactions",
  //       color: "#C93D6E",
  //     },
  //     {
  //       key: "Experiences",
  //       label: "Experiences",
  //       color: "#9B71D2",
  //     },
  //     {
  //       key: "Perfectionism",
  //       label: "Perfectionism",
  //       color: "#7fe3d0",
  //     },
  //     {
  //       key: "Anticipatory",
  //       label: "Anticipatory",
  //       color: "#f5a623",
  //     },
  //     {
  //       key: "Physical",
  //       label: "Physical",
  //       color: "#9B71D2",
  //     },
  //   ],
  // },
  //  "Core Fears: Self-Understanding and Insights": {
  //   type: "dimensional",
  //   display: "",
  //   max:20,
  //   fields: [
  //     {
  //       key: "FA",
  //       label: "Fear of Annihilation",
  //       color: "#C93D6E",
  //     },
  //     {
  //       key: "FM",
  //       label: "Fear of Mutilation",
  //       color: "#9B71D2",
  //     },
  //     {
  //       key: "LA",
  //       label: "Loss of Autonomy",
  //       color: "#7fe3d0",
  //     },
  //     {
  //       key: "FS",
  //       label: "Fear of Separation",
  //       color: "#f5a623",
  //     },
  //     {
  //       key: "ED",
  //       label: "Fear of Humiliation",
  //       color: "#9B71D2",
  //     },

  //   ],
  // },
  "Childhood Abuse Test": {
    type: "dimensional",
    display: "",
    max: 20,
    fields: [
      {
        key: "Ace",
        label: "Ace",
        color: "#C93D6E",
      },
      {
        key: "Resiliency",
        label: "Resiliency",
        color: "#9B71D2",
      },
      {
        key: "Neglect",
        label: "Neglect",
        color: "#7fe3d0",
      },
      {
        key: "Parentification",
        label: "Parentification",
        color: "#f5a623",
      },
      {
        key: "Narcissistic",
        label: "Narcissistic",
        color: "#9B71D2",
      },
    ],
  },
  // "Porn Use Test": {
  //   type: "dimensional",
  //   display: "",
  //   max: 20,
  //   fields: [
  //     {
  //       key: "Emotional",
  //       label: "Emotional Regulation",
  //       color: "#C93D6E",
  //     },
  //     {
  //       key: "Loss",
  //       label: "Loss of Control ",
  //       color: "#9B71D2",
  //     },
  //     {
  //       key: "Escalation",
  //       label: "Tolerance & Escalation",
  //       color: "#7fe3d0",
  //     },
  //     {
  //       key: "Secrecy",
  //       label: "Social Withdrawal",
  //       color: "#f5a623",
  //     },
  //     {
  //       key: "Sexual",
  //       label: "Sexual Health",
  //       color: "#9B71D2",
  //     },
  //   ],
  // },
  "Autism Traits Test": {
    type: "dimensional",
    display: "",
    max: 24,
    fields: [
      {
        key: "SocialSkills",
        label: "Social Skills",
        color: "#C93D6E",
      },
      {
        key: "Repetitiveness",
        label: "Repetitiveness",
        color: "#9B71D2",
      },
      {
        key: "PhysicalIssues",
        label: "Physical Issues",
        color: "#7fe3d0",
      },
      {
        key: "EmotionalIssues",
        label: "Emotional Issues",
        color: "#f5a623",
      },
      {
        key: "ExecutiveFunctioning",
        label: "Executive Functioning",
        color: "#9B71D2",
      },
      {
        key: "CognitiveAbilities",
        label: "Cognitive Abilities",
        color: "#7fe3d0",
      },
    ],
  },
  "Depression, Anxiety and Stress Scale (DASS-21)": {
    type: "subscale",
    fields: [
      { key: "Stress", label: "Stress" },
      { key: "Anxiety", label: "Anxiety" },
      { key: "Depression", label: "Depression" },
    ],
  },

  "Sexual Orientation Test": {
    type: "comparative",
  },
};

export default function getTestUIConfig(testName) {
  return TEST_UI_REGISTRY[testName];
}
